export { isSameErrorMessage };
function isSameErrorMessage(err1, err2) {
    return (err1 === null || err1 === void 0 ? void 0 : err1.message) === (err2 === null || err2 === void 0 ? void 0 : err2.message);
}
